import { buildTestIds } from "application";
import { Loading } from "components/Loading";
import { Fragment } from "react";
import { CartIcon, theme } from "ui";
import { Button, CartIconWrapper, TextButtonCart } from "./styles";

export interface ButtonCartProps {
  sizeProps?: boolean;
  buttonInTheFixedHeader?: boolean;
  mediaScaleBottom?: number;
  actionButton: () => void;
  sendingItemToCart: boolean;
  textVisibleMobile?: boolean;
}

const textButtonCart = "text-button-cart";

const ButtonCart = ({
  mediaScaleBottom,
  textVisibleMobile = false,
  sendingItemToCart,
  actionButton,
  sizeProps,
  buttonInTheFixedHeader,
}: ButtonCartProps) => {
  const handleClick = () => {
    if (!sendingItemToCart) {
      actionButton();
    }
  };

  return (
    <Button
      {...buildTestIds("button-cart")}
      className="add-to-cart"
      width="100%"
      scaleMedia={mediaScaleBottom}
      onClick={handleClick}
      disabled={sendingItemToCart}
      sizeProps={sizeProps}
    >
      {sizeProps && textVisibleMobile ? (
        <Fragment key="add-cart">
          {sendingItemToCart ? (
            <>
              <CartIconWrapper>
                <Loading
                  {...buildTestIds("component-button-submit-loading")}
                  size="medium"
                />
              </CartIconWrapper>
              <TextButtonCart
                {...buildTestIds(textButtonCart)}
                textVisibleMobile={textVisibleMobile as boolean}
              >
                Adicionando...
              </TextButtonCart>
            </>
          ) : (
            <>
              <CartIconWrapper>
                <CartIcon color={theme.colors.neutral.white} width={28} />
              </CartIconWrapper>
              <TextButtonCart
                {...buildTestIds(textButtonCart)}
                textVisibleMobile={textVisibleMobile as boolean}
              >
                Adicionar
              </TextButtonCart>
            </>
          )}
        </Fragment>
      ) : (
        <Fragment key="add-cart">
          {sendingItemToCart ? (
            <>
              <Loading
                {...buildTestIds("component-button-submit-loading")}
                size="medium"
              />
              <TextButtonCart
                {...buildTestIds(textButtonCart)}
                textVisibleMobile={textVisibleMobile as boolean}
              >
                Adicionando ao carrinho...
              </TextButtonCart>
            </>
          ) : (
            <>
              <CartIcon color={theme.colors.neutral.white} width={28} />
              {buttonInTheFixedHeader ? null : (
                <TextButtonCart
                  {...buildTestIds(textButtonCart)}
                  textVisibleMobile={textVisibleMobile as boolean}
                >
                  Adicionar ao carrinho
                </TextButtonCart>
              )}
            </>
          )}
        </Fragment>
      )}
    </Button>
  );
};

export default ButtonCart;
